import ToggleInput from 'shared/components/ToggleInput/ToggleInput';

export default ToggleInput;
